import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveSectionAdvisoryComponent } from './live-section-advisory.component';
import { LiveVideoModule } from '../live-video/live-video.module';
import { SafePipeModule } from '../../pipes/safe/safe.module';

@NgModule({
    imports: [
        CommonModule,
        SafePipeModule,
        LiveVideoModule,
    ],
    exports: [ LiveSectionAdvisoryComponent ],
    declarations: [ LiveSectionAdvisoryComponent ],
    entryComponents: [ LiveSectionAdvisoryComponent ],
})
export class LiveSectionAdvisoryModule { }
